<template>
  <div class="register-container">
    <Steps :current="currentStep">
      <Step
        :title="item.title"
        :icon="item.icon"
        v-for="item in registerSteps"
        :key="item.component"
      />
    </Steps>

    <el-divider />

    <transition name="fade-transform" mode="out-in">
      <component :is="currentComponent" />
    </transition>

    <el-link :underline="false" type="primary" @click="toLoginPage" class="route-login">已有账号，马上登录</el-link>
  </div>
</template>

<script>
//引入组件
import CreateEnterprise from "./components/CreateEnterprise";
import SetPassword from "./components/SetPassword";
import ConfirmAccount from "./components/ConfirmAccount";

import { registerSteps } from "./constant";
export default {
  components: {
    CreateEnterprise,
    ConfirmAccount,
    SetPassword
  },
  data() {
    return {
      currentStep: 0,
      registerSteps: registerSteps,
      phoneNum: ""
    };
  },

  computed: {
    currentComponent() {
      return registerSteps[this.currentStep].component;
    }
  },

  created() {
    if (this.$route.query.currentStep) {
      this.currentStep = parseInt(this.$route.query.currentStep);
    }
  },

  methods: {
    toLoginPage() {
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style scoped lang="scss">
.register-container {
  padding: 25px;

  .el-divider {
    margin: 30px 0 45px 0;
  }
}
.route-login {
  width: 150px;
  margin: 0 auto;
  text-align: center;
  display: block;
}
</style>
